import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = { class: "overlay" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
                'bitmap-link',
                'hover-lift',
                _ctx.border ? 'bitmap-border-gray' : null
             ]),
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args)))
    }, [
      _createElementVNode("div", {
        style: _normalizeStyle(_ctx.size ? `height: ${_ctx.size}px; width: ${_ctx.size}px;` : 'height: 100%; width: 100%;'),
        class: "bitmap-container"
      }, [
        _createElementVNode("img", {
          src: _ctx.src,
          style: _normalizeStyle(_ctx.size != null ? `max-height: ${_ctx.size}px; max-width: ${_ctx.size}px;` : 'max-height:100%;max-width:100%;')
        }, null, 12, _hoisted_2)
      ], 4),
      _createElementVNode("div", {
        style: _normalizeStyle(`font-size: small; font-weight: bold; width: ${_ctx.size}px;`)
      }, _toDisplayString(_ctx.title), 5),
      _withDirectives(_createElementVNode("div", _hoisted_3, null, 512), [
        [_vShow, _ctx.selected]
      ])
    ], 2)
  ]))
}